export default "__VITE_ASSET__0eK5ODcj__"